module.exports = __webpack_public_path__ + "1b72fd98e1e844e5bb9a3f521f5cba02.svg";